import z from "zod";

export const AuthHeaderConfigSchema = z.record(z.string(), z.string());
